import s from './Task.scss'
import cn from 'classnames'
import {
  IoIosCall,
  IoIosMail,
  IoIosPeople,
  IoMdCafe,
  IoMdRestaurant,
  IoIosPaper
} from 'react-icons/io'
import { FaCheckCircle, FaEdit } from 'react-icons/fa'
import { canEditTask } from './helpers'
import { timezoneDate } from 'utils/helpers'

const IconsMapper = {
  CALL: <IoIosCall />,
  EMAIL: <IoIosMail />,
  TASK: <IoIosPaper />,
  MEET: <IoIosPeople />,
  LUNCH: <IoMdCafe />,
  DINNER: <IoMdRestaurant />
}

const Task = ({ task, taskCategory = '', markAsDone, showScheduleTaskModal, markAsNotDone }) => {
  return (
    <div className={s.task}>
      <div className={s.icon}>
        {IconsMapper[task.type]}
        <span
          className={cn(s.date, {
            [s.late]: taskCategory === 'late',
            [s.today]: taskCategory === 'today',
            [s.completed]: taskCategory === 'completed'
          })}
        >
          {timezoneDate(task.dueDate)}
        </span>
      </div>
      <div className={s.subject}>{task.subject}</div>
      <div className={s.actions}>
        {canEditTask(task) && (
          <FaEdit
            data-cy="edit_task"
            className={s.edit}
            onClick={() => showScheduleTaskModal({ edit: true, task })}
          />
        )}
        {task.userId && (
          <div
            title={task.userName}
            className={s.user}
            style={{ backgroundImage: `url(${task.userImage})` }}
          />
        )}
        <FaCheckCircle
          onClick={() => {
            if (!canEditTask(task)) return
            if (task.dateCompleted) {
              markAsNotDone(task.id, taskCategory)
              return
            }
            markAsDone(task.id, taskCategory)
          }}
          className={cn({
            [s.markAsDone]: !task.dateCompleted,
            [s.done]: task.dateCompleted,
            [s.readOnly]: !canEditTask(task)
          })}
          data-cy="mark_task"
        />
      </div>
    </div>
  )
}

export default Task
